import {CSSProperties, useEffect, useState} from "react";

import {BOTTOM_SHEET_ANIMATION_DURATION} from "../constants/bottom_sheet";
import {useSwipeToDismiss} from "./use_swipe_to_dismiss";

interface IOptions {
    enabled?: boolean;
    isClosing: boolean;
    isEntering: boolean;
    onDismiss: () => void;
}

export const useBottomSheetSwipe = (options: IOptions) => {
    const {enabled = true, isClosing, isEntering, onDismiss} = options;
    const [isSwipeExiting, setIsSwipeExiting] = useState(false);
    const [suppressEnter, setSuppressEnter] = useState(false);

    const {isSettling, offsetY, offsetYRef, resetOffset, swipeHandlers} = useSwipeToDismiss(onDismiss, {
        enabled: enabled && !isClosing
    });

    useEffect(() => {
        if (offsetY > 0 || isSettling) setSuppressEnter(true);
    }, [isSettling, offsetY]);

    useEffect(() => {
        if (isEntering) setSuppressEnter(false);
    }, [isEntering]);

    useEffect(() => {
        if (!isClosing) {
            setIsSwipeExiting(false);
            resetOffset();
            return;
        }

        if (offsetYRef.current <= 0) return;

        let outerFrameId = 0;
        let innerFrameId = 0;

        outerFrameId = window.requestAnimationFrame(() => {
            innerFrameId = window.requestAnimationFrame(() => setIsSwipeExiting(true));
        });

        return () => {
            window.cancelAnimationFrame(outerFrameId);
            window.cancelAnimationFrame(innerFrameId);
        };
    }, [isClosing, offsetYRef, resetOffset]);

    const sheetMotionStyle: CSSProperties | undefined = (() => {
        if (!enabled) return undefined;

        if (offsetY > 0 || isSwipeExiting || isSettling) {
            const transform = isSwipeExiting ? "translateY(100%)" : `translateY(${offsetY}px)`;

            let transition: string | undefined;

            if (isSwipeExiting) {
                transition = `transform ${BOTTOM_SHEET_ANIMATION_DURATION} ease-in`;
            } else if (isSettling) {
                transition = `transform ${BOTTOM_SHEET_ANIMATION_DURATION} ease-out`;
            }

            return {
                animation: "none",
                transform,
                transition
            };
        }

        return undefined;
    })();

    return {
        isEntering: isEntering && !suppressEnter,
        sheetMotionStyle,
        swipeHandlers
    };
};
import {CSSProperties, useEffect, useState} from "react";

import {BOTTOM_SHEET_ANIMATION_DURATION} from "../constants/bottom_sheet";
import {useSwipeToDismiss} from "./use_swipe_to_dismiss";

interface IOptions {
    enabled?: boolean;
    isClosing: boolean;
    isEntering: boolean;
    onDismiss: () => void;
}

export const useBottomSheetSwipe = (options: IOptions) => {
    const {enabled = true, isClosing, isEntering, onDismiss} = options;
    const [isSwipeExiting, setIsSwipeExiting] = useState(false);
    const [suppressEnter, setSuppressEnter] = useState(false);

    const {isSettling, offsetY, offsetYRef, resetOffset, swipeHandlers} = useSwipeToDismiss(onDismiss, {
        enabled: enabled && !isClosing
    });

    useEffect(() => {
        if (offsetY > 0 || isSettling) setSuppressEnter(true);
    }, [isSettling, offsetY]);

    useEffect(() => {
        if (isEntering) setSuppressEnter(false);
    }, [isEntering]);

    useEffect(() => {
        if (!isClosing) {
            setIsSwipeExiting(false);
            resetOffset();
            return;
        }

        if (offsetYRef.current <= 0) return;

        let outerFrameId = 0;
        let innerFrameId = 0;

        outerFrameId = window.requestAnimationFrame(() => {
            innerFrameId = window.requestAnimationFrame(() => setIsSwipeExiting(true));
        });

        return () => {
            window.cancelAnimationFrame(outerFrameId);
            window.cancelAnimationFrame(innerFrameId);
        };
    }, [isClosing, offsetYRef, resetOffset]);

    const sheetMotionStyle: CSSProperties | undefined = (() => {
        if (!enabled) return undefined;

        if (offsetY > 0 || isSwipeExiting || isSettling) {
            const transform = isSwipeExiting ? "translateY(100%)" : `translateY(${offsetY}px)`;

            let transition: string | undefined;

            if (isSwipeExiting) {
                transition = `transform ${BOTTOM_SHEET_ANIMATION_DURATION} ease-in`;
            } else if (isSettling) {
                transition = `transform ${BOTTOM_SHEET_ANIMATION_DURATION} ease-out`;
            }

            return {
                animation: "none",
                transform,
                transition
            };
        }

        return undefined;
    })();

    return {
        isEntering: isEntering && !suppressEnter,
        sheetMotionStyle,
        swipeHandlers
    };
};
